module.exports = __webpack_public_path__ + "static/littleWomen9-6796ff5ed9d8545333d367813b933b0a.jpg";